// extracted by mini-css-extract-plugin
module.exports = {"supInputFilter":"SupInputFilter_supInputFilter__Ao8Yi"};